(function() {
  var externalSrc = 'https://cdn.trustindex.io/loader.js?99d952864d51618a31968372969';

  function mountWidget() {
    var mount = document.querySelector('[data-trustindex-mount]');

    if (!mount) {
      return false;
    }

    if (mount.querySelector('script[data-trustindex-external]') || mount.getAttribute('data-trustindex-loaded') === 'true') {
      return true;
    }

    var script = document.createElement('script');
    script.src = externalSrc;
    script.defer = true;
    script.async = true;
    script.setAttribute('data-trustindex-external', 'true');
    mount.setAttribute('data-trustindex-loaded', 'true');
    mount.appendChild(script);
    return true;
  }

  if (!mountWidget()) {
    document.addEventListener('DOMContentLoaded', mountWidget, { once: true });
  }
})();
